import ProxyBaseDAO from "./ProxyBaseDAO";

class ProxyEsqueciSenhaDAO extends ProxyBaseDAO {
  private static instance: ProxyEsqueciSenhaDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyEsqueciSenhaDAO {
    if (!ProxyEsqueciSenhaDAO.instance) {
      ProxyEsqueciSenhaDAO.instance = new ProxyEsqueciSenhaDAO();
    }
    return ProxyEsqueciSenhaDAO.instance;
  }

  public async postEsqueciSenha(email: string, hash: string): Promise<any> {
    return this.post(
      `${this.endpoint}/Consinco/forgot-password-v2?email=${encodeURIComponent(
        email
      )}&hash=${encodeURIComponent(
        hash
      )}`,
      null
    );
  }

  public async postNPS(email: string): Promise<any> {
    return this.post(
      `${this.endpoint}/Consinco/send-nps?email=${encodeURIComponent(
        email
      )}`,
      null
    );
  }
}

export default ProxyEsqueciSenhaDAO;
